import type { CSSProperties } from "react";
import logoSvgRaw from "@/assets/logo.svg?raw";

interface WeddingLogoProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

/** Map repo-root logo.svg (#1A1A1A) to inherit CSS color in the app. */
function themedLogoSvg(raw: string): string {
  return raw
    .replace(/<!--[\s\S]*?-->/g, "")
    .replace(/\s(?:width|height)="[^"]*"/gi, "")
    .replace(/#1a1a1a/gi, "currentColor");
}

const logoSvg = themedLogoSvg(logoSvgRaw);

export function WeddingLogo({ size = 32, className, style }: WeddingLogoProps) {
  return (
    <span
      className={className ? `wedding-logo ${className}` : "wedding-logo"}
      style={{ width: size, height: size, ...style }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: logoSvg }}
    />
  );
}
